// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ig-0";